import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = { ...messages[locale], ...locales(key) }
    }
  })
  return messages
}

function detectInitialLocale(availableLocales, fallback = 'en') {
  try {
    const stored = localStorage.getItem('locale')
    if (stored && availableLocales.includes(stored)) {
      return stored
    }

    const browserLangs = (navigator.languages && navigator.languages.length)
      ? navigator.languages
      : [navigator.language || navigator.userLanguage || '']

    for (const lang of browserLangs) {
      if (availableLocales.includes(lang)) {
        localStorage.setItem('locale', lang)
        return lang
      }
    }

    for (const lang of browserLangs) {
      const base = (lang || '').split('-')[0]
      if (base && availableLocales.includes(base)) {
        localStorage.setItem('locale', base)
        return base
      }
    }
  } catch (e) {
    return fallback
  }

  try {
    localStorage.setItem('locale', fallback)
  } catch (e) {
    return fallback
  }
  return fallback
}

const messages = loadLocaleMessages()
const availableLocales = Object.keys(messages)
const fallbackLocale = process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en'
const initialLocale = detectInitialLocale(availableLocales, process.env.VUE_APP_I18N_LOCALE || 'en')

export default new VueI18n({
  locale: initialLocale,
  fallbackLocale,
  messages
})
